import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Nutrition = props => {
  return (
    <SvgIcon {...props}>
      <path d="M20 9.00005C18.58 6.57005 15.5 5.69005 13 7.00005V2.00005H11V7.00005C8.50002 5.69005 5.42002 6.57005 4.00002 9.00005C2.00002 12.0001 7.00002 21 9.00002 21C11 21 11 20 12 20C13 20 13 21 15 21C17 21 22 12.0001 20 9.00005ZM18.25 12.3801C17.63 14.8501 16.41 17.12 14.7 19C14.5 19 14.27 18.9 14.1 18.75C12.87 17.76 11.13 17.76 9.90002 18.75C9.73002 18.9 9.50002 19 9.30002 19C7.59002 17.13 6.36002 14.8501 5.75002 12.3901C5.50002 11.6601 5.45002 10.8701 5.66002 10.1201C6.24002 9.09005 7.32002 8.43005 8.50002 8.40005C9.06002 8.41005 9.61002 8.54005 10.11 8.79005L11 9.24005H13L13.89 8.79005C14.39 8.54005 14.94 8.41005 15.5 8.40005C16.68 8.43005 17.76 9.08005 18.34 10.1101C18.55 10.8601 18.5 11.6501 18.25 12.3801ZM11 4.00005C5.38002 7.07005 4.11002 2.78005 4.11002 2.78005C4.11002 2.78005 6.77002 -0.809949 11 4.00005Z" />
    </SvgIcon>
  );
};

export default SvgI24Nutrition;
